import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { Constante } from '../../constante';
import { FuseVerticalNavigationBasicItem } from './components/fuse-vertical-navigation-basic-item/basic.component';
import { FuseVerticalNavigationGroupItem } from './components/fuse-vertical-navigation-group-item/group.component';
import { CommonModule } from '@angular/common';
import { Menu } from '../../core/models/interface/menu';
import { FuseNavigationItem } from '../../core/models/interface/navigation.types';
import { AppService } from '../../core/services/app-service';
import { HttpClient } from '@angular/common/http';
import { AuthUtility } from '../../core/utility/auth-utility';
import { environment } from '../../../environments/environment';
import { catchError, of, timeout } from 'rxjs';

@Component({
    selector: 'app-vertical-navigation',
    imports: [
        CommonModule,
        MatIconModule,


        //FuseVerticalNavigationBasicItem,
        FuseVerticalNavigationGroupItem,

    ],
    templateUrl: './vertical-navigation.html',
    styleUrl: './vertical-navigation.scss'
})
export class VerticalNavigation implements OnInit {
    _const = Constante;


    @Input() menu: Menu[] = [];


    //@Input() name: string = this._fuseUtilsService.randomId();


    // ------------
    name: string = 'usdeg9796316';
    @Input() navigation!: FuseNavigationItem[];
    @Input() autoCollapse: boolean = true;

    institutionLogo: string | null = null;
    auroraLogo = 'assets/img/Aurora.png';

    constructor(
        private router: Router,
        private appService: AppService,
        private http: HttpClient,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.loadInstitutionLogo();
    }

    loadInstitutionLogo(): void {
        const payload = AuthUtility.getValidTokenPayload();
        const instId = payload?.institution_id;

        // Temporizador de 1 segundo para mostrar el logo de Aurora como respaldo
        const fallbackTimer = setTimeout(() => {
            if (!this.institutionLogo) {
                this.institutionLogo = this.auroraLogo;
                this.cdr.detectChanges();
            }
        }, 1000);

        if (instId) {
            const url = `${environment.URL_API_AURORA}api/institution-logo/${instId}`;
            this.http.get<any>(url).subscribe({
                next: (res) => {
                    clearTimeout(fallbackTimer);
                    if (res.success === 1 && res.data?.logo) {
                        this.institutionLogo = `data:image/png;base64,${res.data.logo}`;
                    } else {
                        this.institutionLogo = this.auroraLogo;
                    }
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    clearTimeout(fallbackTimer);
                    console.error('Error loading institution logo', err);
                    this.institutionLogo = this.auroraLogo;
                    this.cdr.detectChanges();
                }
            });
        } else {
            clearTimeout(fallbackTimer);
            this.institutionLogo = this.auroraLogo;
        }
    }

    onExpandedMenu(item: Menu) {
        item.expanded = item.expanded ? false : true;
        //////console.log('expanded menu', item.name);
    }

    onActiveMenu(item: Menu) {
        this.desactiveAllMenu(this.menu);

        item.active = item.active ? false : true;
        //////console.log('active menu', item.name);
    }

    desactiveAllMenu(items: Menu[]) {

        items.forEach((x) => {
            x.active = false;

            if (x.submenu) {
                this.desactiveAllMenu(x.submenu);
            }
        });
    }
    onCloseMenu() {
        this.appService.toggleSidebar()
    }
}
